(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["page-content"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialiseGuide = (container) => {
      if (container.dataset.guideEnhancementsReady === 'true') return;
      container.dataset.guideEnhancementsReady = 'true';

      const guide = container.querySelector('[id^="op-"][id$="-guide"], [id*="-v2-guide"]');
      if (!guide) return;

      if (container.dataset.showLastUpdated === 'true' && !guide.querySelector('.op-guide-updated')) {
        const heroContent = guide.querySelector('.op-hero__content');
        const label = container.dataset.lastUpdatedLabel?.trim();
        const date = container.dataset.lastUpdatedDate?.trim();
        if (heroContent && (label || date)) {
          const updated = document.createElement('p');
          updated.className = 'op-guide-updated';
          updated.textContent = [label, date].filter(Boolean).join(': ');
          heroContent.append(updated);
        }
      }

      if (container.dataset.weatherIconMode === 'automatic') {
        const icons = {
          sun: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4"></circle><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.65 17.65l1.42 1.42M2 12h2M20 12h2M4.93 19.07l1.42-1.42M17.65 6.35l1.42-1.42"></path></svg>',
          rain: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 18a4 4 0 0 1-.4-7.98A6 6 0 0 1 18 12a3 3 0 0 1-1 5.83"></path><path d="m8 19-1 2M12 19l-1 2M16 19l-1 2"></path></svg>',
          snow: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2v20M4.22 6.5l15.56 11M4.22 17.5l15.56-11M8.5 4.5 12 7l3.5-2.5M8.5 19.5 12 17l3.5 2.5"></path></svg>',
          leaf: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 4c-7.5 0-13 3.5-13 9a5 5 0 0 0 5 5c5.5 0 8-6.5 8-14Z"></path><path d="M4 20c2-5 6-9 12-12"></path></svg>'
        };
        guide.querySelectorAll('.op-season').forEach((season) => {
          if (season.querySelector('.op-season__icon')) return;
          const copy = season.textContent.toLowerCase();
          let icon = 'sun';
          if (/winter|cold|ski|snow|freeze/.test(copy)) icon = 'snow';
          else if (/rain|wet|monsoon|storm|green season/.test(copy)) icon = 'rain';
          else if (/spring|autumn|fall|harvest/.test(copy)) icon = 'leaf';
          const marker = document.createElement('span');
          marker.className = 'op-season__icon';
          marker.innerHTML = icons[icon];
          season.prepend(marker);
        });
      }

      if (container.dataset.standardiseFlightIcon === 'true') {
        guide.querySelectorAll('.op-transport').forEach((card) => {
          const title = card.querySelector('h3')?.textContent.toLowerCase() || '';
          const category = card.querySelector('.op-label')?.textContent.toLowerCase() || '';
          if (!/(flight|air)/.test(`${title} ${category}`)) return;
          const icon = card.querySelector('.op-transport__icon');
          if (!icon) return;
          icon.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" style="fill:currentColor;stroke:none"><path d="M21 16v-2l-8-5V3.5A1.5 1.5 0 0 0 11.5 2 1.5 1.5 0 0 0 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5L21 16Z"></path></svg>';
        });
      }

      const nav = guide.querySelector('.op-nav');
      if (!nav) return;

      const links = [...nav.querySelectorAll('a[href^="#"]')]
        .map((link) => {
          const target = guide.querySelector(link.getAttribute('href'));
          return target ? { link, target } : null;
        })
        .filter(Boolean);

      if (!links.length) return;

      const setActive = (activeLink) => {
        links.forEach(({ link }) => {
          const selected = link === activeLink;
          link.classList.toggle('is-active', selected);
          if (selected) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      };

      links.forEach(({ link, target }) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setActive(link);
          if (history.replaceState) history.replaceState(null, '', link.getAttribute('href'));
        });
      });

      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
          if (!visible) return;
          const match = links.find(({ target }) => target === visible.target);
          if (match) setActive(match.link);
        },
        { rootMargin: '-18% 0px -68% 0px', threshold: [0, 0.05] }
      );

      links.forEach(({ target }) => observer.observe(target));
      setActive(links[0].link);
    };

    const initialiseAll = () => {
      document
        .querySelectorAll('.page-content[data-outpacker-destination-guide="true"]')
        .forEach(initialiseGuide);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', initialiseAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
